<template>
  <div
    class="custom-message-component-stack"
    :style="{ justifyContent, alignItems }"
    @click="clickHandle"
  >
    <slot />
  </div>
</template>

<script lang="ts" >
import {
  CustomMessageStackComponent,
  getJustifyContentFromAlignment,
  getAlignItemsFromAlignment,
} from '_c/typings/model/chat/text-node';
import { pushUrl } from '@/business/chat/custom-message-util';
import { defineComponent, PropType } from 'vue';


export default defineComponent({
  name: 'CustomMessageStack',
  props: {
    attr: {
      type: Object as PropType<CustomMessageStackComponent>,
      required: true,
    },
  },
  setup(props) {
    function clickHandle(e: Event): void {
      if (props.attr.onClick) {
        e.stopPropagation();
        pushUrl(props.attr.onClick, props.attr.reportData);
      }
    }

    const justifyContent = getJustifyContentFromAlignment(props.attr.alignment);
    const alignItems = getAlignItemsFromAlignment(props.attr.alignment);

    return {
      clickHandle, justifyContent, alignItems,
    };
  },

});


</script>

<style scoped lang="scss">
.custom-message-component-stack {
  display: flex;
  position: relative;
}
</style>
